export const environment = {
    production: false,
    URL_BASE: 'https://appdev.tvsbt.com.br/suite',
    URL_CORE: 'https://appdev.tvsbt.com.br/suite/core',
    PORT: '/elencoadm',
    MODE: 'dev',
    URL_LOGOUT: 'https://login-h.tvsbt.com.br/login',
    URL_LOGIN: 'https://login-h.tvsbt.com.br/login?redirectBack=elencoadm',
    LOCAL_STORAGE_KEY: '16b350b6e1b3e7f4aa24ebf1e57a1eab',
    LOCAL_STORAGE_IV: '0000000000000000',
    APP: 'sbt-elencoadm'
};
